document.addEventListener('DOMContentLoaded',()=>{
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  const route=(path)=>root.replace(/\/$/,'/')+path.replace(/^\//,'');
  document.querySelectorAll('[data-gallery-image]').forEach(button=>button.addEventListener('click',()=>{
    const target=document.querySelector('[id^="ProductImage-"]');
    if(target) target.src=button.dataset.galleryImage;
  }));

  document.querySelectorAll('form.product-form, form[action*="/cart/add"]').forEach(form=>form.addEventListener('submit',async event=>{
    event.preventDefault();
    const button=form.querySelector('.add-button');
    if(button){button.disabled=true;button.innerHTML='Adding to basket…';}
    try{
      const response=await fetch(route('cart/add.js'),{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if(!response.ok) throw new Error('Unable to add this item');
      window.location.assign(route('cart'));
    }catch(error){
      if(button){button.disabled=false;button.innerHTML='Try again <span>→</span>';}
      window.setTimeout(()=>{if(button)button.innerHTML='Add to basket <span>→</span>';},2200);
      console.error(error);
    }
  }));
});
